export function getDocumentVehicles(policyNumber) {
  return {
    type: 'GET_DOCUMENT_VEHICLES',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            mock: false,
            base: '/vehicles/getVehicles',
            query: [
              {
                name: 'policyNumber',
                value: policyNumber,
              },
            ],
          },
        },
        commit: {
          type: 'GET_DOCUMENT_VEHICLES_COMMIT',
        },
        rollback: {
          type: 'GET_DOCUMENT_VEHICLES_ROLLBACK',
        },
      },
    },
  }
}

export function removeDocumentVehicle(vehicleId, documentId, documentType) {
  return {
    type: 'REMOVE_DOCUMENT_VEHICLE',
    payload: {
      vehicleId,
      policyId: documentId,
      documentType,
    },
    meta: {
      offline: {
        effect: {
          // method: 'POST',
          method: 'DELETE',
          query: {
            mock: false,
            base: '/vehicles/removeVehicle',
          },
        },
        commit: {
          type: 'REMOVE_DOCUMENT_VEHICLE_COMMIT',
        },
        rollback: {
          type: 'REMOVE_DOCUMENT_VEHICLE_ROLLBACK',
        },
      },
    },
  }
}

export function addVehicle(vehicle) {
  return {
    type: 'ADD_VEHICLE',
    payload: vehicle,
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            mock: false,
            base: '/vehicles/addVehicle',
          },
        },
        commit: {
          type: 'ADD_VEHICLE_COMMIT',
        },
        rollback: {
          type: 'ADD_VEHICLE_ROLLBACK',
        },
      },
    },
  }
}

export function setDocumentVehicle(vehicle) {
  return {
    type: 'SET_DOCUMENT_VEHICLE',
    payload: { vehicle },
  }
}
export function getDocumentDrivers(policyNumber) {
  return {
    type: 'GET_DOCUMENT_DRIVERS',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            mock: false,
            base: '/drivers/getDrivers',
            query: [
              {
                name: 'policyNumber',
                value: policyNumber,
              },
            ],
          },
        },
        commit: {
          type: 'GET_DOCUMENT_DRIVERS_COMMIT',
        },
        rollback: {
          type: 'GET_DOCUMENT_DRIVERS_ROLLBACK',
        },
      },
    },
  }
}

export function removeDocumentDriver(driverId, documentId, documentType) {
  return {
    type: 'REMOVE_DOCUMENT_DRIVER',
    payload: {
      driverId,
      policyId: documentId,
      documentType,
    },
    meta: {
      offline: {
        effect: {
          // method: 'POST',
          method: 'DELETE',
          query: {
            mock: false,
            base: '/drivers/removeDriver',
          },
        },
        commit: {
          type: 'REMOVE_DOCUMENT_DRIVER_COMMIT',
        },
        rollback: {
          type: 'REMOVE_DOCUMENT_DRIVER_ROLLBACK',
        },
      },
    },
  }
}

export function addDriver(driver) {
  return {
    type: 'ADD_DRIVER',
    payload: driver,
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            mock: false,
            base: '/drivers/addDriver',
          },
        },
        commit: {
          type: 'ADD_DRIVER_COMMIT',
        },
        rollback: {
          type: 'ADD_DRIVER_ROLLBACK',
        },
      },
    },
  }
}

export function setDocumentDriver(driver) {
  return {
    type: 'SET_DOCUMENT_DRIVER',
    payload: { driver },
  }
}

export function getDocuments() {
  return {
    type: 'GET_DOCUMENTS',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            base: '/documents/getEdocs',
            mock: false,
          },
        },
        commit: {
          type: 'GET_DOCUMENTS_COMMIT',
        },
        rollback: {
          type: 'GET_DOCUMENTS_ROLLBACK',
        },
      },
    },
  }
}

export function clearDocuments() {
  return {
    type: 'CLEAR_DOCUMENTS',
  }
}

export function setDocument(document) {
  return {
    type: 'SET_DOCUMENT',
    payload: { document },
  }
}

export function clearDocument() {
  return {
    type: 'CLEAR_DOCUMENT',
  }
}

export function clearDocumentFetchTimestamp() {
  return {
    type: 'CLEAR_DOCUMENT_FETCH_TIMESTAMP',
  }
}

export function setPolicy(policy) {
  return {
    type: 'SET_POLICY',
    payload: { policy },
  }
}

export function clearPolicy() {
  return {
    type: 'CLEAR_POLICY',
  }
}

export function getPoliciesDetails() {
  return {
    type: 'GET_POLICIES_DETAILS',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            base: '/documents/getPoliciesDetails',
            mock: false,
          },
        },
        commit: {
          type: 'GET_POLICIES_DETAILS_COMMIT',
        },
        rollback: {
          type: 'GET_POLICIES_DETAILS_ROLLBACK',
        },
      },
    },
  }
}

export function getPolicyDetails(id) {
  return {
    type: 'GET_POLICY_DETAILS',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            base: '/documents/getPolicyDetails',
            mock: false,
            query: [
              {
                name: 'id',
                value: id,
              },
            ],
          },
        },
        commit: {
          type: 'GET_POLICY_DETAILS_COMMIT',
        },
        rollback: {
          type: 'GET_POLICY_DETAILS_ROLLBACK',
        },
      },
    },
  }
}

export function setAddedToWallet(documentId) {
  return {
    type: 'SET_ADDED_TO_WALLET',
    payload: {
      documentId,
    },
  }
}

export function createSlip(data) {
  return {
    type: 'DOCUMENTS_SLIP_CREATE',
    payload: data,
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            mock: false,
            base: '/documents/slip',
          },
        },
        commit: {
          type: 'DOCUMENTS_SLIP_CREATE_COMMIT',
        },
        rollback: {
          type: 'DOCUMENTS_SLIP_CREATE_ROLLBACK',
        },
      },
    },
  }
}
